import {
    Wrench,
    FileSignature,
    Users,
    ClipboardList,
    KeyRound,
    Server,
    Printer,
    CalendarClock,
    BarChart3,
    UserCircle2,
} from "lucide-react";

const modules = [
    {
        letter: "A",
        icon: Wrench,
        title: "Interventi e rapportini",
        text: "Pianifica attività, assegna tecnici, registra sessioni di lavoro, genera rapportini PDF professionali e mantieni lo storico completo del cliente.",
    },
    {
        letter: "B",
        icon: FileSignature,
        title: "Contratti di assistenza",
        text: "Gestisci contratti prepagati a monte ore, contratti flat, rinnovi, consumi, ore residue, marginalità e scadenze.",
    },
    {
        letter: "C",
        icon: Users,
        title: "CRM clienti",
        text: "Una scheda cliente completa con dati, sedi, contatti, storico attività, preventivi, contratti, dispositivi e servizi attivi.",
    },
    {
        letter: "D",
        icon: ClipboardList,
        title: "Preventivi e opportunità",
        text: "Carica il PDF del preventivo, scegli se renderlo visibile al cliente, monitora scadenze, stati, accettazioni e statistiche commerciali.",
    },
    {
        letter: "E",
        icon: KeyRound,
        title: "MSP, licenze e servizi SaaS",
        text: "Centralizza servizi Microsoft 365, Sophos, Azure, NinjaOne, Zyxel Nebula e altri servizi ricorrenti collegandoli al cliente.",
    },
    {
        letter: "F",
        icon: Server,
        title: "Dispositivi e asset",
        text: "Registra dispositivi, seriali, apparati, stampanti, endpoint, firewall, server e tutta la dotazione tecnica associata al cliente.",
    },
    {
        letter: "G",
        icon: Printer,
        title: "Noleggio e costo copia",
        text: "Monitora contratti di noleggio, stampanti, letture, condizioni, scadenze e informazioni operative legate al costo copia.",
    },
    {
        letter: "H",
        icon: CalendarClock,
        title: "Scadenziario operativo",
        text: "Gestisci scadenze non fiscali, rinnovi, verifiche periodiche, adempimenti ISO 9001/14001/27001, manutenzioni e attività ricorrenti.",
    },
    {
        letter: "I",
        icon: BarChart3,
        title: "Reportistica e KPI",
        text: "Trasforma i dati operativi in informazioni utili: ore lavorate, saturazione, marginalità, contratti, vendite, scadenze e performance.",
    },
    {
        letter: "J",
        icon: UserCircle2,
        title: "Area cliente",
        text: "Offri al cliente una dashboard dedicata per consultare servizi attivi, contratti, licenze, dispositivi, documenti e preventivi visibili.",
    },
];

export default function Modules() {
    return (
        <section
            id="moduli"
            data-testid="modules-section"
            className="relative bg-slate-50 py-24 sm:py-28 lg:py-32"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <div className="max-w-3xl">
                    <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-cyan-700">
                        <span className="h-px w-8 bg-cyan-500" />
                        Moduli
                    </span>
                    <h2
                        data-testid="modules-title"
                        className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900"
                    >
                        Tutti i moduli che servono a chi lavora davvero sul campo.
                    </h2>
                </div>

                <div
                    data-testid="modules-grid"
                    className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3"
                >
                    {modules.map((m) => (
                        <article
                            key={m.letter}
                            data-testid={`module-card-${m.letter}`}
                            className="reveal group relative rounded-2xl bg-white ring-1 ring-slate-200 p-7 hover:ring-cyan-400/50 hover:-translate-y-0.5 hover:shadow-lg transition"
                        >
                            <div className="flex items-start justify-between">
                                <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-slate-900 text-cyan-300 ring-1 ring-slate-800">
                                    <m.icon className="w-5.5 h-5.5" strokeWidth={2} />
                                </span>
                                <span className="font-display text-2xl font-extrabold text-slate-200 group-hover:text-cyan-500 transition">
                                    {m.letter}
                                </span>
                            </div>
                            <h3 className="mt-5 font-display text-lg font-semibold text-slate-900">
                                {m.title}
                            </h3>
                            <p className="mt-2.5 text-[14.5px] leading-relaxed text-slate-600">
                                {m.text}
                            </p>
                            <span className="absolute inset-x-7 bottom-0 h-[2px] bg-gradient-to-r from-cyan-500 to-teal-400 rounded-full opacity-0 group-hover:opacity-100 transition" />
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
